/**
 * add by: hong.rong 2020/10/26
 * name: video组件
 * notes:
 */
// @ts-nocheck
import React, { useCallback, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import VideoJs from 'video.js'
import './plugins/videojs-rotate-player-plugin'
import './plugins/videojs-marker'
// import 'videojs-contrib-hls' // 添加hls插件，以保证播放m3u8格式的视频
import 'video.js/dist/video-js.css'
import './index.less'

const isUrlRe = /^(?:https?:)?\/\//i

export default function VideoPlayer({
  src = '',
  wrappedClassName = '',
  wrappedStyle = {},
  config = {},
  poster,
  rotatePlayer = true,
  setPlayerIns = () => {},
  ...restProps
}: any) {
  const playerRef: any = useRef({ src })
  const playerIns: any = useRef()
  // const currentTime = useRef(0);
  useEffect(() => {
    let player: any
    if (isUrlRe.test(src)) {
      const options = {
        controls: true,
        ...config,
      }
      player = VideoJs(playerRef.current, options)
      playerIns.current = player
      if (rotatePlayer) {
        player.rotatePlayerPlugin()
      }
      // 动态设置封面
      if (isUrlRe.test(poster)) {
        player.poster(poster)
      }
      player.on('click', function (event) {
        // 阻止事件传播导致antd弹框关闭问题
        event.stopPropagation()
      })
      // 全屏事件
      //  player.on('fullscreenchange', function() {
      //    // 触发全屏事件
      //    let isFullscreen = playerIns.current.isFullscreen();
      //    if (isFullscreen) {
      //      // 全屏播放时继续之前的进度播放
      //      console.log(currentTime.current)
      //      playerIns.current.currentTime(currentTime.current);
      //      playerIns.current.play().catch(() => {});
      //    }
      //  })
      player.src({ src })
      if (config.autoplay) {
        // 自动播放有时候会不太灵，需要强化一下
        player.play().catch(() => {})
      }
      setPlayerIns(player)
      // 显示海报和播放按钮
      // player.current.markers({
      //   markerStyle: {
      //     // 标记样式
      //     width: '4px',
      //     height: '6px',
      //     bottom: '2px',
      //     'background-color': '#3A71A8',
      //     position: 'absolute'
      //   },
      //   markerTip: {
      //     display: false// 不显示标记的tip
      //   },
      //   markers: [
      //     {
      //       time: 1.5
      //     },
      //     {
      //       time: 2
      //     },
      //     {
      //       time: 5
      //     },
      //     {
      //       time: 9
      //     }
      //   ]
      // })
    }
  }, [src])
  useEffect(() => {
    return () => {
      // 销毁
      playerIns.current.dispose()
      playerRef.current = null
      playerIns.current = null
      setPlayerIns(null)
    }
  }, [])

  return (
    <div
      style={{
        height: 400,
        width: 600,
        ...wrappedStyle,
      }}
      className={classNames('cb-video-wrapper', wrappedClassName)}
    >
      <video {...restProps} ref={playerRef} className="video-js" />
    </div>
  )
}
